import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { ComplaintComponent } from './complaint.component';
import { CONFIG_PROVIDER, ConfigProvider } from './config.service';
import { AldagiHeaderComponent } from './aldagi-header/aldagi-header.component';
import { AldagiFooterComponent } from './aldagi-footer/aldagi-footer.component';
import { ErrorsHandler } from './error-handler';

export function configProviderFactory(provider: ConfigProvider) {
  return () => provider.loadConfig();
}

@NgModule({
  declarations: [ComplaintComponent, AldagiHeaderComponent, AldagiFooterComponent],
  imports: [BrowserModule, HttpClientModule, FormsModule],
  providers: [
    CONFIG_PROVIDER,
    {
      provide: APP_INITIALIZER,
      useFactory: configProviderFactory,
      deps: [ConfigProvider],
      multi: true
    },
    {
      provide: ErrorHandler,
      useClass: ErrorsHandler
    }
  ],
  bootstrap: [ComplaintComponent]
})
export class AppModule {}
